import React from 'react';
import {
    Subtitle,
    BlackFullLabel,
    DiamondBullet,
    MediumPrimaryButton,
    MediumSecondaryButton
} from '@worthy-npm/clarity'
import {isMobile} from 'helpers/ApplicationHelper'

const LargeCTAcard = (props) => {

    const {isSecondaryCTA, title, bullets, ctaText, CTAcallBack, type} = props
    let labelColor, labelText
    
    switch (type) {
        case 'service':
            labelText = 'Service'
            labelColor = '#0D52AE'
            break;
        case 'consultation':
            labelText = 'Consultation'
            labelColor = '#5D9228'
            break
        default:
            labelText = 'info'
            labelColor = ''
            ctaText = 'Info'
            break;
    }

    return (
        <div className="large-cta-card d-flex flex-col">
                <div className="top-container d-flex flex-col">
                    <BlackFullLabel text={labelText} overrideCSS={{backgroundColor: labelColor, color: 'white', textTransform: 'none', marginBottom: '15px'}}/>
                    <Subtitle text={title} overrideCSS={{fontSize: isMobile()? '22px': ''}}/>
                    <div className="bullets-container">
                    {
                        bullets.map((bullet, i)=>{
                            return(
                                <DiamondBullet key={i} iconColor='purple' html={bullet} overrideCSS={{margin: '4px 0', color: 'black'}}/>
                            )
                        })
                    }
                    </div>
                </div>
                {isSecondaryCTA?
                <MediumSecondaryButton text={ctaText}
                                       overrideCSS={{border: '2px solid #2F80ED', width: '100%', borderRadius: '2px', color: '#2F80ED', padding: '9px 30px 10px'}}
                                       overrideWrapperCSS={{width: '100%'}}
                                       disableAnimation={true}
                                       click={(stopAnimation)=>CTAcallBack(stopAnimation)}/>:
                <MediumPrimaryButton text={ctaText}
                                       overrideCSS={{border: '2px solid #2F80ED', width: '100%', borderRadius: '2px'}}
                                       overrideWrapperCSS={{width: '100%'}}
                                       disableAnimation={true}
                                       click={(stopAnimation)=>CTAcallBack(stopAnimation)}/>
                }
            </div>
    );
}

export default LargeCTAcard;